module.exports = __webpack_public_path__ + "img/deepreport.f833a826.png";